import { ChannelType } from "~/components/basic/Share/types";

export type NormalShareItem = {
  channel: ChannelType;
  // 分享图片
  img: string;
  // 分享标题
  title: string;
  // 分享描述
  description: string;
  // 分享链接
  url: string;
};

export enum ShareChannelName {
  Whatsapp = "whatsapp",
  Line = "line",
  Instagram = "instagram",
  Facebook = "facebook",
  Twitter = "twitter",
  CopyLink = "copylink",
}

export const ShareChannelNameToID = {
  [ShareChannelName.Whatsapp]: ChannelType.Whatsapp,
  [ShareChannelName.Line]: ChannelType.Line,
  [ShareChannelName.Instagram]: ChannelType.Instagram,
  [ShareChannelName.Facebook]: ChannelType.Facebook,
  [ShareChannelName.Twitter]: ChannelType.Twitter,
  [ShareChannelName.CopyLink]: ChannelType.CopyLink,
};

export const ShareChannelIdToName = {
  [ChannelType.Whatsapp]: ShareChannelName.Whatsapp,
  [ChannelType.Line]: ShareChannelName.Line,
  [ChannelType.Instagram]: ShareChannelName.Instagram,
  [ChannelType.Facebook]: ShareChannelName.Facebook,
  [ChannelType.Twitter]: ShareChannelName.Twitter,
  [ChannelType.CopyLink]: ShareChannelName.CopyLink,
};

export type ShareContentsMap = {
  [key in ShareChannelName]: NormalShareItem;
};
